export var EField;
(function (EField) {
    EField["Header"] = "_header";
    EField["Info"] = "info";
    EField["TenantAmount"] = "tenantAmount";
    EField["TenantBankAccountId"] = "tenantBankAccountId";
    EField["OwnerAmount"] = "ownerAmount";
    EField["OwnerBankAccountId"] = "ownerBankAccountId";
    EField["BrokerAmount"] = "brokerAmount";
    EField["BrokerBankAccountId"] = "brokerBankAccountId";
    EField["Signers"] = "signers";
    EField["SignAsBroker"] = "signAsBroker";
    EField["Broker"] = "broker";
    EField["TenantReceiver"] = "tenantReceiver";
    EField["OwnerReceiver"] = "ownerReceiver";
    EField["JudicialRelease"] = "judicialRelease";
    EField["VerdictPdf"] = "verdictPdf";
    EField["Payer"] = "payer";
    EField["IdentityDocuments"] = "identityDocuments";
    EField["IdentityDocumentAccountId"] = "accountId";
    EField["IdentityDocumentIdentityFrontDocumentId"] = "identityFrontDocument";
    EField["IdentityDocumentIdentityBackDocumentId"] = "identityBackDocument";
    EField["DateOfExpiry"] = "dateOfExpiry";
})(EField || (EField = {}));
